import {
  ClientTransportResources,
  makeClientTransportResources,
} from "@afar-research/client-runtime/connection";
import { createResourceLedger } from "@afar-research/shared/resourceLedger";
import * as Layer from "effect/Layer";

export const clientResourceLedger = createResourceLedger();
export const clientTransportResourceLedger = clientResourceLedger;

export const clientTransportResources = makeClientTransportResources({
  ledger: clientResourceLedger,
});

export const clientTransportResourcesLayer = Layer.succeed(
  ClientTransportResources,
  clientTransportResources,
);
